import type { SettingGridRow } from "../settingsTree";

import { segmentParts } from "../settingsTree";
import style from "./style.module.scss";

interface Props {
	row: SettingGridRow;
}

const INHERITED_TOOLTIP = "No row for this name applies, so the code reads it from the level above";

/** Where the value comes from: the row's segment, one pill per part, after "Inherited from …" when it comes from a level above */
export function SourcePills({ row }: Props) {
	if (row.source === "default" || row.source === "none")
		return <span className={style.defaultBadge}>{row.source === "default" ? "Default" : "Not set"}</span>;

	const parts = segmentParts(row.winner);
	return (
		<div className={style.pills}>
			{row.source === "inherited" && (
				<span className={style.inheritedBadge} title={INHERITED_TOOLTIP}>
					Inherited from {row.winner.name}
				</span>
			)}
			{parts.length ? (
				parts.map((part) => (
					<span key={part} className={style.segmentBadge}>
						{part}
					</span>
				))
			) : (
				<span className={style.setBadge}>Company-wide</span>
			)}
		</div>
	);
}
